<template>
  <v-list-item two-line class="px-0 mx-0">
    <v-list-item-avatar size="64">
      <v-avatar size="64" color="nightDark">
        <v-icon size="36">
          {{ icon }}
        </v-icon></v-avatar
      >
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title class="text-h5"> {{ title }}</v-list-item-title>
      <v-list-item-subtitle class="text-caption primary--text pt-1"
        >{{ subtitle }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action-text
      v-if="callCenterStore.callCenterStep > 1 && step == 1"
      class="text-right"
    >
      <div class="text-body-1">{{ callCenterStore.fullname }}</div>
      <div class="text-caption white--text mt-1">
        <b>{{ callCenterStore.phone }}</b>
      </div>
    </v-list-item-action-text>

    <v-list-item-action-text
      v-if="callCenterStore.callCenterStep > 2 && step == 2"
      class="d-flex flex-column align-end"
    >
      <div class="text-caption mb-1">
        Ödeme :
        <b class="white--text">{{ callCenterStore.paymentType }}</b>
        | Şube :
        <b class="white--text">{{ callCenterStore.deliveryCustomer }} </b>
      </div>

      <v-chip color="primary" label
        >{{ callCenterStore.deliveryDate | moment("DD MMMM, dddd") }} | Saat
        {{ callCenterStore.data.delivery.deliveryhour }}
      </v-chip>
    </v-list-item-action-text>

    <v-list-item-action-text
      v-if="callCenterStore.callCenterStep > 3 && step == 3"
      class="d-flex flex-column align-end"
    >
      <div class="text-caption mb-1">
        Ürün :
        <b class="white--text">{{ callCenterStore.totalProducts }} Adet</b> | Paket :
        <b class="white--text">{{ callCenterStore.packageProducts }} Adet</b>
      </div>
      <v-chip color="secondary" label class="text-overline">{{
        callCenterStore.sumProductsPrice | currency
      }}</v-chip>
    </v-list-item-action-text>

    <v-list-item-action-text
      v-if="callCenterStore.callCenterStep > 4 && step == 4"
      class="d-flex flex-column align-end"
    >
      <div class="text-caption mb-1">
        <span v-if="callCenterStore.data.invoice.invaddrtaxtdept"
          >VD :
          <b class="white--text">{{ callCenterStore.data.invoice.invaddrtaxtdept }}</b>
          | </span
        >VN :
        <b class="white--text">{{ callCenterStore.data.invoice.invaddrvatno }} </b>
      </div>

      <v-chip color="primary" outlined label>{{ callCenterStore.invoiceName }} </v-chip>
    </v-list-item-action-text>
  </v-list-item>
</template>

<script>
import { useCallCenterStore } from "@/stores/callCenter";

export default {
  props: {
    step: {
      type: Number,
      required: false,
      default: 0,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "Başlık",
    },
    subtitle: {
      type: String,
      required: false,
      default: "Alt Başlık",
    },
  },
  setup() {
    const callCenterStore = useCallCenterStore();
    return {
      callCenterStore,
    };
  },
};
</script>

<style></style>
